import { ID } from '../../utils/codecUtils';
import { failedAutomationResultSchema } from '../models/automationBlocker.schema';

export const get = (automationBlockerId: ID) => {
  return {
    endpoint: `/automation_blockers/${automationBlockerId}`,
    method: 'GET',
    responseSchema: failedAutomationResultSchema,
  } as const;
};
